import pro1 from "../assets/project1.png";
import pro2 from "../assets/project2.png";
import pro3 from "../assets/project3.png";
import pro4 from "../assets/project4.png";
import pro6 from "../assets/project6.png";
import pro7 from "../assets/project7.png";
import CarHub from "../assets/CarHub.png";
import NewTab from "../assets/newtab.png";
import uploadfilesds from "../assets/uploadfilesds.png";
import DraCamilaImg from "../assets/DraCamilaImg.png";
import ed from "../assets/ed.png";
import okr from "../assets/okr.png";
import aiModelLearn from "../assets/aimodellearn.png";

const ProjectCardData = [
  {
    id: 15,
    imgsrc: aiModelLearn,
    title: "Projeto SaaS AI Model Learn",
    text: "Tecnologias: Next.js, Typescript, Supabase, Tailwind CSS, NextAuth v5, Framer-motion, Google Search Console SEO, Shadcn/UI",
    view: "/projeto-ai-model-learn",
    isNew: true,
    isSaaS: true,
  },
  {
    id: 13,
    imgsrc: okr,
    title: "Projeto SaaS OKR Planner",
    text: "Tecnologias: Next.js, Typescript, Supabase, Tailwind CSS, NextAuth v5, Framer-motion, Google Search Console SEO, Shadcn/UI, Stripe Payments",
    view: "/projeto-okr-planner",
    isNew: true,
    isSaaS: true,
  },
  {
    id: 12,
    imgsrc: ed,
    title: "Projeto SaaS Edição Direta",
    text: "Tecnologias: Next.js, Typescript, Firebase, Tailwind CSS, NextAuth v5, Google Search Console SEO, Shadcn/UI",
    view: "/projeto-edicao-direta",
    isNew: true,
    isSaaS: true,
  },
  {
    id: 1,
    imgsrc: uploadfilesds,
    title: "Projeto SaaS Upload Files DS",
    text: "Tecnologias: Google Analytics, Google Search SEO, TypeScript, Next.js, Stripe Payments, Tailwind CSS, NextAuth v5, MongoDB, EdgeStore, ShadCN",
    view: "/projeto-uploadfilesds",
    isNew: true,
    isSaaS: true,
  },
  {
    id: 2,
    imgsrc: DraCamilaImg,
    title: "Projeto Website Institucional",
    text: "Tecnologias: NextJS, TypeScript, Tailwind CSS.",
    view: "/projeto-website-institucional",
    isNew: true,
    isInstitucional: true,
  },
  {
    id: 3,
    imgsrc: CarHub,
    title: "Projeto CarHub",
    text: "Tecnologias: NextJS, TypeScript, Tailwind CSS.",
    view: "/projeto-carhub",
  },
  {
    id: 4,
    imgsrc: pro7,
    title: "Projeto Downloader System em NEXTJS",
    text: "Tecnologias: NextJS, JSON, API do EmailJS.",
    view: "/projeto-downloader-system-nextjs",
  },
  {
    id: 5,
    imgsrc: pro1,
    title: "Projeto Ecommerce",
    text: "Tecnologias: ReactJS, NextJS, Sanity (API backend), Stripe (API de pagamento).",
    view: "/projeto-ecommerce-john-dala",
  },

  {
    id: 8,
    imgsrc: pro2,
    title: "Projeto HBanks Responsivo",
    text: "Tecnologias: ReactJS, Vite, TailwindCSS.",
    view: "/projeto-hbanks-responsivo",
  },
  {
    id: 9,
    imgsrc: pro6,
    title: "Projeto Downloader System (Protótipo)",
    text: "Tecnologias: WordPress.",
    view: "/projeto-downloader-system",
  },
  {
    id: 10,
    imgsrc: pro4,
    title: "Projeto Portfolio Responsivo",
    text: "Tecnologias: ReactJS, API do YouTube, API do EmailJS.",
    view: "/projeto-portfolio-responsivo",
  },
  {
    id: 11,
    imgsrc: pro3,
    title: "Projeto Viagem Responsivo",
    text: "Tecnologias: ReactJS, JSON.",
    view: "/projeto-viagem-responsivo",
  },
  {
    id: 14,
    imgsrc: NewTab,
    title: "Projeto NewTab",
    text: "Tecnologias: NextJS, testando LocalStorage.",
    view: "/projeto-newtab",
  },
];

export default ProjectCardData;
